<template>
  <div class="refinance-row">
    <div class="cell">
      <h5>{{ createdAtText }}</h5>
    </div>
    <div class="cell">
      <h5>{{ activity.title }}</h5>
    </div>
    <div class="cell">
      <h5>{{ admin.name }}</h5>
    </div>
  </div>
</template>

<script>
import { toLocaleTH } from "@/lib/dateTime"

export default {
  props: {
    activity: {
      type: null,
      default: undefined,
    },
    createdAt: {
      type: null,
      default: undefined,
    },
    admin: {
      type: null,
      default: undefined,
    },
  },
  computed: {
    createdAtText() {
      return toLocaleTH(this.createdAt).toFormat("dd MMMM yyyy HH:mm น.")
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.refinance-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr) 150px;
  grid-gap: 15px;
  align-items: center;

  padding: ($space / 3) $space;
}

.refinance-row > .cell {
  > h5 {
    font-size: 14px;
  }

  > h5 {
    line-height: 1.6;
    margin: 0;
  }
}
</style>
